import { isNil } from 'ramda';
import useProductPricesRenderer from '../../../../../../products/prices/useProductPricesRenderer';
import { ProductCardsPriceConfig } from '../../productCardsBlock.types';

type UseProductCardsPriceParams = Omit<ProductCardsPriceConfig, 'isVisible'>;

export const useProductCardsPrice = ({
  prices,
  isRetailDisabled,
  isWholesaleDisabled,
}: UseProductCardsPriceParams) => {
  const { pricesConfig, showRetailPrice, showMarkup, markup } = useProductPricesRenderer({
    prices,
  });
  const { minWholesalePrice, minPromotionalPrice, minRetailPrice } = pricesConfig;

  return {
    hasPrices: prices.length > 0,
    wholesale:
      isNil(minWholesalePrice) || isWholesaleDisabled
        ? undefined
        : { value: minWholesalePrice, promotionValue: minPromotionalPrice },
    retail:
      isNil(minRetailPrice) || !showRetailPrice || isRetailDisabled
        ? undefined
        : { value: minRetailPrice, markup: showMarkup ? markup : null },
  };
};
